import * as CurrencyFormatter from "currencyformatter.js";
import { Logger } from "../log/Logger";
import { StringUtil } from "../string/StringUtil";
import { WebUtil } from "../web/WebUtil";
/**
 * CurrencyFormat.ts
 *
 * Holds a language code like `en_GB` or `de`.
 */
export class CurrencyFormat {
    constructor(currencyCode) {
        this.currency = currencyCode;
    }
}
/**
 * CurrencyUtil.ts
 */
export class CurrencyUtil {
    static setFormatByCode(value) {
        CurrencyUtil.HIDE_CURRENCY = StringUtil.isTrue(WebUtil.getUrlParameter("hideCurrency"));
        Logger.forceLog(`Set Format By Code: ${value}`);
        Logger.forceLog(`Hiding Currency: ${CurrencyUtil.HIDE_CURRENCY}`);
        if (value) {
            CurrencyUtil.DEFAULT = new CurrencyFormat(value);
        }
    }
    /**
     * Converts a number to a currency string.
     */
    static format(value, format) {
        let formatter = format ? format : CurrencyUtil.DEFAULT;
        if (CurrencyUtil.HIDE_CURRENCY) {
            formatter = CurrencyUtil.NONE;
        }
        const parsedValue = CurrencyUtil.parseValue(value);
        if (CurrencyUtil.isUseMBK(formatter.currency)) {
            return CurrencyUtil.formatWithAbbreviation(parsedValue, formatter);
        }
        return CurrencyFormatter.format(parsedValue, formatter);
    }
    static getCurrencySymbol() {
        return CurrencyFormatter.symbols[CurrencyUtil.DEFAULT.currency];
    }
    /**
     * Clamps `value` to a positive real number, 0 inclusive.
     * @param value - Number to be validated.
     */
    static parseValue(value) {
        let parsed = isNaN(value) ? 0 : value;
        if (parsed < 0) {
            parsed = 0;
        }
        return parsed;
    }
    static formatWithAbbreviation(value, format) {
        if (!value && value !== 0) {
            return "";
        }
        const symbol = CurrencyFormatter.symbols[format.currency] || format.currency;
        if (value >= 1000000000) {
            return symbol + (value / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
        }
        else if (value >= 1000000) {
            return symbol + (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        else if (value >= 1000) {
            return symbol + (value / 1000).toFixed(2).replace(/\.?0+$/, '') + 'K';
        }
        return symbol + value.toString();
    }
    static isUseMBK(currencyCode) {
        const locale = CurrencyFormatter.locales[currencyCode];
        return locale && locale.useMBK === true;
    }
}
CurrencyUtil.NONE = new CurrencyFormat("NONE");
/**
 * Current formatter
 * @see {@link CurrencyFormat}
 */
CurrencyUtil.DEFAULT = CurrencyUtil.NONE;
//# sourceMappingURL=CurrencyUtil.js.map